import React, { useState } from 'react';
import useFeature from '../../hooks/useFeature';
import UpsellModal from './UpsellModal';

// Plan-gating wrapper. Renders `children` when the merchant's plan enables
// `feature`. When locked:
//   - if a `fallback` is provided, render that instead;
//   - otherwise render nothing inline and pop the <UpsellModal>.
// Pass `onUpgrade` to route the modal's "Upgrade" action (e.g. to billing).
const RequireFeature = ({ feature, fallback, onUpgrade, children }) => {
  const enabled = useFeature(feature);
  const [dismissed, setDismissed] = useState(false);

  if (enabled) {
    return <>{children}</>;
  }

  if (fallback !== undefined) {
    return <>{fallback}</>;
  }

  if (dismissed) {
    return null;
  }

  return (
    <UpsellModal
      feature={feature}
      onClose={() => setDismissed(true)}
      onUpgrade={onUpgrade}
    />
  );
};

export default RequireFeature;
